var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "playlist-edit 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.328 7.92193L8.06238 16.1875L4 17L4.81248 12.9376L13.0781 4.67203C13.2908 4.45899 13.5434 4.28998 13.8215 4.17467C14.0996 4.05936 14.3976 4 14.6987 4C14.9997 4 15.2978 4.05936 15.5759 4.17467C15.854 4.28998 16.1066 4.45899 16.3193 4.67203L16.328 4.6807C16.541 4.8934 16.71 5.14602 16.8253 5.4241C16.9406 5.70218 17 6.00027 17 6.30132C17 6.60236 16.9406 6.90045 16.8253 7.17853C16.71 7.45661 16.541 7.70923 16.328 7.92193Z",
    stroke: "#979592",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4bb1b47414f39e8bbaa782c4d8a26c5f.svg";
export { ForwardRef as ReactComponent };